import Cookies from 'js-cookie';
import {
    LOGIN_SUCCESS,
    LOGIN_ERROR,
    LOGOUT,
    ACCOUNT_LOGIN_SUCCESS,
    ACCOUNT_LOGIN_ERROR,
    ACCOUNT_LOGOUT,
    SET_ACCOUNT,
    SET_USER,
    SET_BASKET_COUNT,
} from 'context/actions/auth';

let user;
if (process.browser) {
    user = JSON.parse(localStorage.getItem('user'));
}

let account;
if (process.browser) {
    account = JSON.parse(localStorage.getItem('account'));
}

const initialState = {};

if (user)
    Object.assign(initialState, {
        loggedIn: true,
        user,
    });

if (account)
    Object.assign(initialState, {
        accountLoggedIn: true,
        account,
    });

const reducer = (state, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            Cookies.set('auth_token', action.data.token, { expires: 3 });
            localStorage.setItem('user', JSON.stringify(action.data));
            return { ...state, loggedIn: true, user: action.data };
        case LOGIN_ERROR:
            localStorage.removeItem('user');
            Cookies.remove('auth_token');
            return { ...state, loggedIn: false, user: null };
        case LOGOUT:
            localStorage.removeItem('user');
            Cookies.remove('auth_token');
            return { ...state, loggedIn: false, user: null };
        case ACCOUNT_LOGIN_SUCCESS:
            Cookies.set('account_auth_token', action.data.token, { expires: 30 });
            localStorage.setItem('account', JSON.stringify(action.data));
            return { ...state, accountLoggedIn: true, account: action.data };
        case ACCOUNT_LOGIN_ERROR:
            localStorage.removeItem('account');
            Cookies.remove('account_auth_token');
            return { ...state, accountLoggedIn: false, account: null };
        case ACCOUNT_LOGOUT:
            localStorage.removeItem('account');
            Cookies.remove('account_auth_token');
            return { ...state, accountLoggedIn: false, account: null };
        case SET_ACCOUNT: {
            const newState = { ...state, accountLoggedIn: true, account: action.data };
            localStorage.setItem('account', JSON.stringify({ ...action.data }));
            return newState;
        }
        case SET_BASKET_COUNT: {
            // Зөвхөн basketCount-ыг шинэчилнэ — type, payment_status гэх мэт
            // бусад field-үүдэд нөлөөлөхгүй.
            if (!state.account) return state;
            const updatedAccount = {
                ...state.account,
                accountInfo: {
                    ...state.account.accountInfo,
                    basketCount: action.data,
                },
            };
            localStorage.setItem('account', JSON.stringify(updatedAccount));
            return { ...state, account: updatedAccount };
        }
        case SET_USER:
            localStorage.setItem('user', JSON.stringify({ ...action.data }));
            return { ...state, loggedIn: true, user: action.data };
        default:
            return state;
    }
};

const authReducer = [reducer, initialState];

export default authReducer;
